import { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext, PaycheckContext, ThemeContext } from "../../../../../../../../contexts";
import { useNavigate, useLocation } from "react-router-dom";
import { Paper } from "@material-ui/core";
import PlanHeader from "../../../../../../../shared/enrollment/planCode/PlanHeader";
import { useRouteParamSSN } from "../../../../../../../../hooks";
import useRouteParam from "../../../../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../utils/api";
import { AdminEnrollmentInitDataQuery } from "../../../../../../../../utils/api/pages/enrollmentInit";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Plan } from "../../../../../../../../@types/plan.types";
import ExtractRouteQueryParams from "../../../../../../../../utils/commonFunctions/extractRouteQueryParams";
import { Member } from "../../../../../../../../@types/member.types";
import ApproveActiveEnrollment from "../../../../../../../shared/approveActiveEnrollment/ApproveActiveEnrollment";
import Button from "@material-ui/core/Button";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

const GltdForm = (): JSX.Element => {
	const { theme, setTheme } = useContext(ThemeContext);
	const [plan, setPlan] = useState<Plan>();
	const queryPlanCode = useRouteParamSSN("pc");
	const queryGroupNumber = useRouteParam("gn");
	const routeQueryParam = ExtractRouteQueryParams().join("&");
	const querySSN = useRouteParam("qs");
	const [effectiveDate, setEffectiveDate] = useState("");
	const [enrollmentDate, setEnrollmentDate] = useState<string>("");
	const queryEnrollmentId = useRouteParam("eid");
	const [employee, setEmployee] = useState<Member>();
	const [enrollmentStatus, setEnrollmentStatus] = useState<string>("");
	const { paycheck } = useContext(PaycheckContext);
	const navigate = useNavigate();
	const location = useLocation();

	// const handleApproveEffectiveDateChange = useCallback(
	// 	(_date: MaterialUiPickersDate, name: string | null | undefined) => {
	// 		const date = new Date(_date as Date);
	// 		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
	// 		setEffectiveDate(parsedDate);
	// 	},
	// 	[]
	// );

	const handleApproveEffectiveDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string | null | undefined) => {
			const parsedDate = _date as unknown as string;

			setEffectiveDate(parsedDate);
		},
		[]
	);

	const handleRedirectToMemberDetails = useCallback(() => {
		const pathname = `/employer/member?${routeQueryParam}`;
		navigate(pathname);
	}, [navigate, routeQueryParam]);

	const handleSubmitEnrollmentClick = useCallback(async () => {
		if (!queryEnrollmentId || !plan) return;
		if (!effectiveDate) {
			alert("Effective date is required");
			return;
		}
		try {
			const effDate = new Date(effectiveDate as unknown as Date);

			const payload = {
				_id: queryEnrollmentId,
				plan_name: plan.plan_name,
				effective_date: effDate.getFullYear() + "-" + (effDate.getMonth() + 1) + "-" + effDate.getDate()
			};
			const response = await trackPromise(api.enrollments.AddAutoApproveEnrollment(payload));
			if (response) {
				alert("Auto Approve Enrollment Added Succesfully!");
				handleRedirectToMemberDetails();
			}
		} catch (error) {
			alert("Auto Approve Enrollment Submission unsuccessful!");
			throw error;
		}
	}, [queryEnrollmentId, plan, effectiveDate, handleRedirectToMemberDetails]);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN || !queryEnrollmentId) {
			return;
		}
		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number,
			enrollment_status: "ACTIVE"
		};

		const { enrollments, theme } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));
		// console.log("enrollments", enrollments);
		setTheme(Object.assign({}, theme));
		const { employee, total_premium, enrollment_date, enrollment_status, plan_name, effective_date } =
			enrollments[0];
		setEnrollmentStatus(enrollment_status);
		setPlan(Object.assign({}, enrollments[0].plan));
		setEnrollmentDate(enrollment_date as unknown as string);
		setEmployee(Object.assign({}, employee));
		setEffectiveDate(effective_date as unknown as string);
	}, [queryEnrollmentId, queryGroupNumber, queryPlanCode, querySSN, setTheme]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	if (plan === undefined) {
		return <></>;
	}

	return (
		<div className="GLTD-classes theme-container">
			<Paper className="paper-container">
				<PlanHeader planCode={plan?.plan_code} planName="Group Short Term Disability" />
				<div className="theme-plan-section-margin" />
				<div className="theme-plan-icon-item-center-container">
					<div>
						<FiberManualRecordIcon
							className="theme-plan-point-header-icon"
							style={{ color: theme.primary_color }}
						/>
					</div>
					<div className="theme-plan-point-header-text">Class One</div>
				</div>
				<div className="theme-plan-sub-inner-section-margin" />
				<div style={{ marginLeft: "20px" }}>
					<div className="theme-plan-description-text">
						Long Term Disability (LTD) Plan offers you security of earnings (upon approval from Lincoln
						Financial Group) should you become disabled.
					</div>
					<div className="theme-plan-sub-inner-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<FiberManualRecordIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							The LTD benefit is a company-paid benefit for all designated full-time employees; there is
							no cost to the insured.
						</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<FiberManualRecordIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">Elimination period: 180 days.</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<FiberManualRecordIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							The benefit pays the insured 50% of base pay to age 65, or until no longer disabled.
						</div>
					</div>
					<div className="sub-point-section">
						<div className="theme-plan-icon-item-center-container">
							<div>
								<FiberManualRecordIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Maximum Disability Benefit $1,500/mo</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<FiberManualRecordIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">Minimum Disability Benefit $100/mo</div>
						</div>
						<br></br>
						<div className="theme-plan-icon-item-center-container">
							<div>
								<FiberManualRecordIcon className="theme-plan-subpoint-icon" />
							</div>
							<div className="theme-plan-subpoint-text">
								Claims are processed for approval and paid by Lincoln Financial Group (if approved)
							</div>
						</div>
					</div>
				</div>
				<div className="theme-plan-section-margin" />
				<div className="approve-active-enrollment">
					<ApproveActiveEnrollment
						enrollmentDate={enrollmentDate}
						enrollmentStatus={enrollmentStatus}
						effectiveDate={effectiveDate}
						handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
					/>
				</div>
				<div className="enrollment-action-button-container" id="enrollment-action-button-container">
					<Button
						className="button-green"
						onClick={handleSubmitEnrollmentClick}
						variant="contained"
						style={{
							pointerEvents: "unset"
						}}
					>
						<span className="button-label-with-icon">Submit</span>
						<span>
							<FiberManualRecordIcon className="button-icon" />
						</span>
					</Button>
				</div>
			</Paper>
		</div>
	);
};

export default GltdForm;
